import { isFinite, isEmpty, includes } from 'lodash';
// ---- external imports ----

import db from './tradersDb';
// ---- local imports ----


export function clearMessages() {
	return db.inbox.clear();
}

export function addMessage(newMessage) {
	return db.inbox.put(newMessage);
}

export function addMessages(newMessages) {
	return db.inbox.bulkPut(newMessages);
}

export function markAsRead(id) {
	return db.inbox.update(id, {seen: true});
}

export function getAll() {
	return db.inbox.toArray();
}

export function getAllReversed() {
	return db.inbox.reverse().toArray();
}

/**
 * Returns messages array filtered by filters object
 * 
 * @param { year: number, month?: number[], category?: string[] } filters 
 * @param {boolean} isReversed default false
 * @returns Object[] array of filtered messages
 */
export async function getMessages(filters, isReversed = false) {
	if(!isFinite(filters.year)) {
		return [];
	}

	const hasMonthFilter = !isEmpty(filters.month);
	const hasCategoryFilter = !isEmpty(filters.category);
	const hasFilters = hasMonthFilter || hasCategoryFilter;

	const messagesCollection = db.inbox.where('year').equals(filters.year);

	if (hasFilters) {
		messagesCollection.and((msg) => {
			return (!hasMonthFilter || includes(filters.month, msg.month))
				&& (!hasCategoryFilter || includes(filters.category, msg.category));
		});
	}

	return isReversed
		? messagesCollection.reverse().toArray()
		: messagesCollection.toArray();
}

export function readAllMessages() {
	return db.inbox.toCollection().modify({ seen: true });
}

export async function getLastMessageId() {
	const lastMessage = await db.inbox.toCollection().last();
	
	return lastMessage?.id || 0;
}

export function deleteMessagesWithIdGreaterThan(id) {
	if(id === undefined || id === null) {
		return;
	}

	if(id === 0) {
		return db.inbox.clear();
	}

	return db.inbox.where('id').above(id).delete();
}

export function getUnreadMessagesIds() {
	return db.inbox.filter((msg) => !msg.seen).keys();
}

export function unreadMessages(messagesIds) {
	if(!messagesIds || messagesIds.length === 0) {
		return;
	}

	return db.inbox.where('id').anyOf(messagesIds).modify({ seen: false });
}
